import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative flex flex-col h-screen" }

import { defineAsyncComponent } from 'vue'

// stores
import { useAuthStore } from 'SkynamoApp/AuthStore'

// components

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const TheAppBar = defineAsyncComponent(() => import('SkynamoApp/TheAppBar'))

const authStore = useAuthStore()


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TheAppBar), {
      class: "w-full sticky",
      "use-updated": true,
      onOnLogout: _cache[0] || (_cache[0] = ($event: any) => (_unref(authStore).logoutAndRedirect()))
    }),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1 /* STABLE */
    }))
  ]))
}
}

})